// * --color-text: hsl(0, 0%, 100%);
// * --color-background: hsl(210, 30%, 8%);
// --color-blurred-background: hsla(210, 30%, 8%, 0.85);
// * --color-primary: hsl(333, 100%, 52%);
// --color-secondary: hsl(230, 92%, 63%);
// --color-tertiary: hsl(53, 100%, 50%);
// --color-decorative: hsl(200, 50%, 60%);
// --color-muted: hsl(210, 38%, 15%);
// --color-muted-background: hsla(210, 38%, 15%, 0.85);
// --color-info: hsl(230, 92%, 63%);
// --color-success: hsl(160, 100%, 40%);
// --color-success-background: hsla(160, 100%, 40%, 0.1);
// --color-error: hsl(340, 95%, 60%);
// --color-error-background: hsla(340, 95%, 43%, 0.1);
// --color-alert: hsl(30, 100%, 50%);
// --color-alert-background: hsla(38, 100%, 50%, 0.1);
// --color-venn-0: hsl(250, 100%, 50%);
// --color-venn-1: hsl(175, 100%, 50%);
// --color-gray-100: hsl(210, 15%, 20%);
// --color-gray-200: hsl(210, 15%, 25%);
// --color-gray-300: hsl(210, 10%, 40%);
// --color-gray-400: hsl(210, 9%, 45%);
// --color-gray-500: hsl(210, 8%, 50%);
// --color-gray-600: hsl(210, 12%, 55%);
// --color-gray-700: hsl(210, 14%, 66%);
// --color-gray-900: hsl(210, 25%, 88%);
// --color-gray-1000: hsl(210, 25%, 96%);
// --color-subtle-background: hsl(210, 30%, 8%);
// --color-subtle-floating: hsl(210, 22%, 15%);
// --color-homepage-light: hsla(200, 100%, 85%, 0);
// --color-homepage-dark: hsla(200, 100%, 85%, 0.1);
// --color-homepage-bg: hsl(210, 30%, 8%);
// --syntax-bg: hsl(210, 30%, 12%);
// --syntax-highlight: hsl(210, 30%, 18%);
// --syntax-txt: #FFF;
// --syntax-comment: #6c8998;
// --syntax-prop: #FF39A8;
// --syntax-bool: #FFD600;
// --syntax-val: #61747D;
// --syntax-str: rgb(155, 109, 255);
// --syntax-name: #C653FF;
// --syntax-del: #FF5555;
// --syntax-regex: #ffd700;
// --syntax-fn: rgb(0, 190, 255);
// --prefers-dark: true;
// --scrollbar-width: 12px;

export const COLORS = {
	text: {
		light: 'hsl(0, 0%, 10%)',
		dark: 'hsl(0, 0%, 100%)',
	},
	background: {
		light: 'hsl(0, 0%, 100%)', // WHITE
		dark: 'hsl(220, 100%, 9%)', // OXFORD BLUE
	},
	primary: {
		light: 'hsl(1, 81%, 73%)', // LIGHT CORAL
		dark: 'hsl(48, 84%, 88%)', // LEMON MERINGUE
		// dark: 'hsl(342, 100%, 84%)', // NADESHIKO PINK
		// dark: 'hsl(53, 90%, 50%)', // YELLOW // hsl(40, 94%, 49%) // MUSTARD
	},
	secondary: {
		light: 'hsl(223, 53%, 36%)', // DARK CORNFLOWER BLUE
		dark: 'hsl(342, 100%, 80%)', // NADESHIKO PINK
	},
	tertiary: {
		light: 'hsl(170, 91%, 66%)', // Darkish Cyan
		dark: 'hsl(185, 100%, 93%)', // LIGHT CYAN
		// dark: 'hsl(48, 84%, 88%)', // LEMON MERINGUE
	},
	// Grays, scaling from least-noticeable to most-noticeable
	'gray-100': { light: 'hsl(225, 25%, 95%)', dark: 'hsl(210, 15%, 20%)' },
	'gray-200': { light: 'hsl(225, 16%, 90%)', dark: 'hsl(210, 15%, 25%)' },
	'gray-300': { light: 'hsl(225, 8%, 80%)', dark: 'hsl(210, 10%, 40%)' },
	'gray-400': { light: 'hsl(225, 8%, 70%)', dark: 'hsl(210, 9%, 45%)' },
	'gray-500': { light: 'hsl(225, 7%, 60%)', dark: 'hsl(210, 8%, 50%)' },
	'gray-600': { light: 'hsl(225, 15%, 50%)', dark: 'hsl(210, 12%, 55%)' },
	'gray-700': { light: 'hsl(225, 12%, 40%)', dark: 'hsl(210, 14%, 66%)' },
	'gray-800': { light: 'hsl(225, 25%, 20%)', dark: 'hsl(210, 25%, 88%)' },
	'gray-900': { light: 'hsl(225, 20%, 15%)', dark: 'hsl(210, 20%, 96%)' },
	'gray-1000': {
		light: 'hsl(225, 15%, 15%)',
		dark: 'hsl(210, 25%, 96%)',
	},
};

export const COLOR_MODE_KEY = 'color-mode';
export const INITIAL_COLOR_MODE_CSS_PROP = '--initial-color-mode';
